import React, { useState, createContext, useContext, useEffect } from "react";

const AuthContext = createContext(null);

const buildAuthHeader = (authState) => {
  const accessToken = authState?.access || authState?.token;
  if (!accessToken) {
    return {};
  }

  const scheme = authState?.access ? "Bearer" : "Token";
  const headers = { Authorization: `${scheme} ${accessToken}` };
  if (authState?.selected_branch && !authState?.user?.is_superuser) {
    headers["X-Selected-Shop"] = String(authState.selected_branch);
  }
  return headers;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;
    const timestamp = localStorage.getItem("timestamp");

    const now = new Date().getTime();
    const isExpired = !timestamp || now - timestamp > 24 * 60 * 60 * 1000;

    return isExpired ? null : user;
  });

  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("timestamp", new Date().getTime());
    } else {
      localStorage.removeItem("user");
      localStorage.removeItem("timestamp");
    }
  }, [user]);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("timestamp");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        hasAuthToken: Boolean(buildAuthHeader(user).Authorization),
        buildAuthHeader: () => buildAuthHeader(user),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
